import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./dashboard/dashboard.component').then((mod) => mod.DashboardComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'warehouse-logistics',
    loadComponent: () =>
      import('./warehouse-logistics/warehouse-logistics.component').then(
        (mod) => mod.WarehouseLogisticsComponent
      ),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'my-processes',
    loadComponent: () =>
      import('./my-processes/my-processes.component').then((mod) => mod.MyProcessesComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'my-processes/details/:id',
    loadComponent: () =>
      import('./my-processes/details/my-processes-details.component').then(
        (mod) => mod.MyProcessesDetailsComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'warehouse-logistics/details/:id',
    loadComponent: () =>
      import('./warehouse-logistics/details/warehouse-details.component').then(
        (mod) => mod.WarehouseDetailsComponent
      ),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'deceased/register',
    loadComponent: () =>
      import('./deceased/register/register.component').then((mod) => mod.RegisterComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'deceased/pickup/:id',
    loadComponent: () =>
      import('./deceased/pickup/pickup.component').then((mod) => mod.PickupComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'deceased/deliver',
    loadComponent: () =>
      import('./deceased/deliver/deliver.component').then((mod) => mod.DeliverComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'deceased/deliver/:id',
    loadComponent: () =>
      import('./deceased/deliver/deliver.component').then((mod) => mod.DeliverComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'deceased/pickup-different-company',
    loadComponent: () =>
      import('./deceased/pickup-different-company/pickup-different-company.component').then(
        (mod) => mod.PickupDifferentCompanyComponent
      ),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'calendar',
    loadComponent: () =>
      import('./calendar/calendar.component').then((mod) => mod.CalendarComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'calendar/details',
    loadComponent: () =>
      import('./calendar/details/calendar-details.component').then(
        (mod) => mod.CalendarDetailsComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'wizard/my-processes',
    redirectTo: '/dashboard', //Remove this when wizard is deployable
    // loadComponent: () =>
    //   import('./wizard/my-processes/my-processes-wizard.component').then(
    //     (mod) => mod.MyProcessesWizardComponent
    //   ),
    // canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'wizard',
    redirectTo: '/dashboard', //Remove this when wizard is deployable
    // loadComponent: () => import('./wizard/wizard.component').then((mod) => mod.WizardComponent),
    // canActivate: [AuthGuard, AdminGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
